import SendMySelfButton from '@/components/molecules/SendMyselfButton'
import StartOverButton from '@/components/molecules/StartOverButton'
import Categories from '@/components/organisms/Categories'
import ConfiguratorHeader from '@/components/organisms/ConfiguratorHeader'
import IncludedSection from '@/components/organisms/IncludedSection'
import PriceSection from '@/components/organisms/PriceSection'

export default function ConfiguratorGrid() {
  return (
    <>
      <ConfiguratorHeader />
      <IncludedSection />
      <Categories />
      <PriceSection />

      <section className="my-4 flex flex-col items-center justify-center md:mt-12 md:flex-row md:gap-4">
        <SendMySelfButton />
        <StartOverButton />
      </section>
    </>
  )
}
